import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CaseManagementAPI } from '../shared/constant/url.constant';

@Injectable({
  providedIn: 'root'
})
export class CaseManagementService {

  constructor(private readonly http: HttpClient) {}
  // Utility to get headers with user-id and agency-id if available
  private getHeaders(includeUserId: boolean = true): HttpHeaders {
    const userId = sessionStorage.getItem('userId');
    const agencyId = sessionStorage.getItem('agencyId');
    const token = sessionStorage.getItem('applicationToken');
    let headers = new HttpHeaders();
    if(token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    if (includeUserId && userId) {
      headers = headers.set('user-id', userId);
    }
    if (agencyId) {
      headers = headers.set('agency-id', agencyId);
    }
    return headers;
  }

  getAllCases(
    id: string,
    keyword: string,
    workflowStatuses: string,
    startDate: string,
    endDate: string,
    minRemainingDays: string,
    maxRemainingDays: string,
    page: string,
    limit: string,
    assignee: string
  ) {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('keyword', keyword)
      .set('workflowStatuses', workflowStatuses)
      .set('startDate', startDate)
      .set('endDate', endDate)
      .set('minRemainingDays', minRemainingDays)
      .set('maxRemainingDays', maxRemainingDays)
      .set('assignedTo', assignee);
    const url = `${CaseManagementAPI.GetAllCases}${id}/cases`;
    return this.http.get(url, { params, headers: this.getHeaders() });
  }

  getAssigneeDropdownData(roles: string) {
    const params = new HttpParams().set('roles', roles);
    const url = `${CaseManagementAPI.GetAssigneeDropdownData}/assignee`;
    return this.http.get(url, { params, headers: this.getHeaders() });
  }
  getAllUsers(id: string) {
    const url = `${CaseManagementAPI.GetAllCases}${id}/users`;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  assignCaseToUser(reqBody: any, caseId: string) {
    const url = `${CaseManagementAPI.UpdateApplicationBlock}${caseId}/assign`;
    return this.http.post(url, reqBody, { headers: this.getHeaders() });
  }
  saveComments(caseId: string, comments: string) {
    const requestBody = {
      applicationId: caseId,
      remark: comments,
      remarkType: "ASSIGNEE_NOTE"
    };
    const url = `${CaseManagementAPI.AddComment}`;
    return this.http.post(url, requestBody, { headers: this.getHeaders() });
  }
  getCaseDetails(caseId: string) {
    const url = `${CaseManagementAPI.GetCaseById}${caseId}`;
    return this.http.get(url, { headers: this.getHeaders() });
  }
  addDocument(caseId: string, formData: FormData) {
    const url = `${CaseManagementAPI.GetAllDocuments}${sessionStorage.getItem('agencyId')}/case/${caseId}/documents`;
    return this.http.post(url, formData, { headers: this.getHeaders() });
  }
  deleteDocument(caseId: string, documentId: string) {
    const url = `${CaseManagementAPI.GetAllDocuments}${sessionStorage.getItem('agencyId')}/case/${caseId}/documents/${documentId}`;
    return this.http.delete(url, { headers: this.getHeaders(), responseType: 'text' });
  }
  viewDocument(caseId: string, documentId: string) {
    const url = `${CaseManagementAPI.GetAllDocuments}${sessionStorage.getItem('agencyId')}/case/${caseId}/documents/${documentId}/content`;
    return this.http.get(url, { headers: this.getHeaders(), responseType: 'blob' });
  }
  downloadDocument(caseId: string, documentId: string) {
    const url = `${CaseManagementAPI.GetAllDocuments}${sessionStorage.getItem('agencyId')}/case/${caseId}/documents/${documentId}/download`;
    return this.http.get(url, { headers: this.getHeaders(), responseType: 'blob' });
  }
  getAllDocuments(caseId: any) {
    const url = `${CaseManagementAPI.GetAllDocuments}${sessionStorage.getItem('agencyId')}/case/${caseId}/documents`;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  getWorkflowStatus(statusType: string) {
    const agencyId = sessionStorage.getItem('agencyId');
    const params = agencyId ? new HttpParams().set('agencyId', agencyId).set('statusType', statusType) : undefined;
    const url = `${CaseManagementAPI.GetWorkflowStatus}${agencyId}`;
    return this.http.get(url, { params, headers: this.getHeaders(false) });
  }
  getWorkflowStatusById(id: string) {
    const params = id ? new HttpParams().set('id', id) : undefined;
    const url = `${CaseManagementAPI.GetWorkflowStatusById}/${id}`;
    return this.http.get(url, { params, headers: this.getHeaders(false) });
  }
  getHistoryByCaseId(caseId: string) {
    const url = `${CaseManagementAPI.GetHistory}${caseId}`;
    return this.http.get(url, { headers: this.getHeaders(false) });
  }
  getEligibilityConditions() {
    const agencyId = sessionStorage.getItem('agencyId');
    const url = `${CaseManagementAPI.GetEligibilityConditions}${agencyId}`;
    return this.http.get(url, { headers: this.getHeaders(false) });
  }
  getAllNotifications(page: number, limit: number) {
    const params = new HttpParams().set('page', page).set('limit', limit);
    return this.http.get(`${CaseManagementAPI.GetAllNotifications}`, { headers: this.getHeaders(), params });
  }
  viewCase(deliveryId: string) {
    const url = `${CaseManagementAPI.ViewCase}${deliveryId}/read`;
    return this.http.put(url, {}, { headers: this.getHeaders(false), responseType: 'text' });
  }
  getDeterminationLetterLanguages() {
    const agencyId = sessionStorage.getItem('agencyId');
    const url = `${CaseManagementAPI.GetDeterminationLetterLanguages}${agencyId}`;
    return this.http.get(url, { headers: this.getHeaders(false) });
  }
}